export const CapeeshWebState = {
    LessonPreview: 'LessonPreview',
    CapeeshWebStudent: 'CapeeshWebStudent',
}
